import { useOktaAuth } from '@okta/okta-react';
import FlagProvider from '@unleash/proxy-client-react';
import PropTypes from 'prop-types';

import { logger } from '../logger';
import { getAppConfig } from '../utilities';

const UnleashWrapper = ({ children }) => {
  const config = getAppConfig('unleashConfig');
  const auth = useOktaAuth();

  const { authState } = auth;

  let userId = '';
  if (authState?.isAuthenticated) {
    const {
      idToken: {
        claims: { sub }
      }
    } = authState;
    userId = sub;
  }

  logger.info('unleashConfig ==>', config.url, config.env);

  return <FlagProvider config={{ ...config, context: { userId } }}>{children}</FlagProvider>;
};

UnleashWrapper.propTypes = {
  children: PropTypes.instanceOf(Object).isRequired
};

export default UnleashWrapper;
